export interface PhoneMaskConfig {
  mask: string
  length: number
  name: string
}

export const PHONE_MASKS: Record<string, PhoneMaskConfig> = {
  '+38': { mask: '+38 (###) ###-##-##', length: 12, name: 'Ukraine' }, // 38 + 10 digits = 12 ✓
  '+1': { mask: '+1 (###) ###-####', length: 11, name: 'USA/Canada' }, // 1 + 10 digits = 11 ✓
  '+44': { mask: '+44 ## #### ####', length: 13, name: 'UK' }, // 44 + 11 digits = 13 ✓
  '+49': { mask: '+49 ### ########', length: 13, name: 'Germany' }, // 49 + 11 digits = 13 ✓
  '+33': { mask: '+33 # ## ## ## ##', length: 12, name: 'France' }, // 33 + 10 digits = 12 ✓
  '+39': { mask: '+39 ### ### ####', length: 12, name: 'Italy' }, // 39 + 10 digits = 12 ✓
  '+34': { mask: '+34 ### ### ###', length: 11, name: 'Spain' }, // 34 + 9 digits = 11 ✓
  '+48': { mask: '+48 ### ### ###', length: 11, name: 'Poland' }, // 48 + 9 digits = 11 ✓
  '+31': { mask: '+31 # ########', length: 11, name: 'Netherlands' }, // 31 + 9 digits = 11 ✓
  '+32': { mask: '+32 # ## ## ## ##', length: 12, name: 'Belgium' }, // 32 + 10 digits = 12 ✓
  '+43': { mask: '+43 # #### ####', length: 11, name: 'Austria' }, // 43 + 9 digits = 11 ✓
  '+41': { mask: '+41 ## ### ## ##', length: 12, name: 'Switzerland' }, // 41 + 10 digits = 12 ✓
  '+46': { mask: '+46 ## ### ## ##', length: 12, name: 'Sweden' }, // 46 + 10 digits = 12 ✓
  '+47': { mask: '+47 ### ## ###', length: 10, name: 'Norway' }, // 47 + 8 digits = 10 ✓
  '+45': { mask: '+45 ## ## ## ##', length: 10, name: 'Denmark' }, // 45 + 8 digits = 10 ✓
  '+358': { mask: '+358 ## ### ####', length: 12, name: 'Finland' }, // 358 + 9 digits = 12 ✓
}

export const detectCountryMask = (value: string): PhoneMaskConfig => {
  if (!value) {
    return PHONE_MASKS['+38'] // default Ukraine
  }

  const cleaned = value.replace(/\D/g, '')
  
  // Sort by code length (longest first) to match more specific codes first
  const sortedCodes = Object.keys(PHONE_MASKS).sort((a, b) => 
    b.replace('+', '').length - a.replace('+', '').length
  )
  
  for (const code of sortedCodes) {
    const numericCode = code.replace('+', '')
    if (cleaned.startsWith(numericCode)) {
      return PHONE_MASKS[code]
    }
  }
  
  return PHONE_MASKS['+38'] // default Ukraine
}

export const getCountryByCode = (countryCode: string): PhoneMaskConfig | null => {
  return PHONE_MASKS[countryCode] || null
}

export const getAllCountries = (): Array<{ code: string; config: PhoneMaskConfig }> => {
  return Object.entries(PHONE_MASKS).map(([code, config]) => ({
    code,
    config
  }))
}